import { Button, Card, Col, Image, List, Row, Typography } from 'antd';
import { CaretSpinIcon } from 'components/atoms/CaretSpinIcon';
import { SalesOrderModel } from 'models/SalesOrderModel';
import React, { LegacyRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';
import { useMeasure } from 'react-use';
import { usePostAttachmentMutation } from 'redux/services/useMamaBearService';

interface Props {
  data: SalesOrderModel | undefined;
}

export const PostedAttachmentsPanel = ({ data }: Props): JSX.Element => {
  const [visible, setVisible] = useState<boolean>(true);
  const [postAttachment] = usePostAttachmentMutation();

  const [ref, { height }] = useMeasure();
  const expandAnimation = useSpring({
    config: { friction: 12 },
    height: visible ? height : 0
  });

  return (
    <>
      <Row
        align="middle"
        justify="space-between"
        onClick={(): void => setVisible(!visible)}
        style={{ background: '#FFEAC1', padding: '0px 10px', width: '100%', marginBottom: visible ? 8 : 0, borderRadius: 5, cursor: 'pointer' }}>
        <Typography.Title level={4} style={{ marginBottom: 0, padding: 12 }}>
          Attachments
        </Typography.Title>
        <Button style={{ width: 115 }} type="text" onClick={(): void => setVisible(!visible)} key="show-attachments" icon={<CaretSpinIcon isOpen={visible} />}>
          {visible ? 'Collapse' : 'Expand'}
        </Button>
      </Row>
      <animated.div style={{ ...{ overflow: 'hidden', width: '100%' }, ...expandAnimation }}>
        {visible && (
          <div ref={ref as LegacyRef<HTMLDivElement>}>
            <List
              dataSource={data?.attachments}
              grid={{ column: 3, gutter: [6, 6] as any }}
              renderItem={(item): JSX.Element => (
                <Col>
                  <Card bodyStyle={{ padding: 8 }} key={item.name}>
                    <Row align="middle" justify="space-between">
                      <Col>
                        <Image
                          fallback={
                            'data:image/svg+xml;base64,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'
                          }
                          width={48}
                          height={48}
                          src={(item as unknown as { url: string }).url}
                        />
                        <Typography.Link href={(item as unknown as { url: string }).url} style={{ marginLeft: 15 }}>
                          {item.name}
                        </Typography.Link>
                      </Col>
                      <Button
                        style={{ display: data?.attachments?.find((item) => item.name === item.name)?.submittedToD365 ? 'none' : undefined }}
                        onClick={() => postAttachment({ salesOrderId: data?.id as string, fileName: item.name })}>
                        Post to D365
                      </Button>
                    </Row>
                  </Card>
                </Col>
              )}
            />
          </div>
        )}
      </animated.div>
    </>
  );
};
